var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    attrs: {
      label: _vm.label,
      items: _vm.items,
      dense: _vm.dense,
      "return-object": "",
      loading: _vm.isFindServicePending,
      "search-input": _vm.searchInput,
      rules: _vm.rules,
      placeholder: _vm.placeholder,
      clearable: _vm.clearable,
      disabled: _vm.disabled,
      "item-text": _vm.itemText,
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.searchInput = $event
      },
      "update:search-input": function ($event) {
        _vm.searchInput = $event
      },
    },
    scopedSlots: _vm._u(
      [
        _vm._l(_vm.$slots, function (_, name) {
          return {
            key: name,
            fn: function () {
              return [_vm._t(name)]
            },
            proxy: true,
          }
        }),
        !_vm.isFindServicePending && _vm.areMoreItems
          ? {
              key: "append-item",
              fn: function () {
                return [
                  _c(
                    "v-list-item",
                    { on: { click: _vm.loadMore } },
                    [_c("v-list-item-title", [_vm._v("Load more...")])],
                    1
                  ),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
    model: {
      value: _vm.selectedItem,
      callback: function ($$v) {
        _vm.selectedItem = $$v
      },
      expression: "selectedItem",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }